import { Stack, Switch, Typography, useTheme } from "@mui/material";

export type FlatRowSwitchProps = {
	label: string;
	checked?: boolean;
	onChange?: (checked: boolean) => void;
	onBlur?: () => void;
	disabled?: boolean;
	isLast?: boolean;
	redesigned?: boolean;
};

export const FlatRowSwitch = ({
	label,
	checked,
	onChange,
	onBlur,
	disabled,
	isLast,
	redesigned = false,
}: FlatRowSwitchProps) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack
			component="label"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			sx={{
				width: "100%",
				px: spacingTokens.lg,
				minHeight: 48,
				cursor: disabled ? "default" : "pointer",
				borderBottom: isLast ? "none" : `1px solid ${palette.surface.border}`,
			}}
		>
			<Typography variant="body2" mr={spacingTokens.xl}>
				{label}
			</Typography>
			<Switch
				redesigned={redesigned}
				checked={!!checked}
				onChange={(_, next) => onChange?.(next)}
				onBlur={onBlur}
				disabled={disabled}
			/>
		</Stack>
	);
};
